module.exports = __webpack_public_path__ + "static/img/WMP769_A.841f809.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WMP769_A.jpg
// module id = 5YBd
// module chunks = 0